import React, { useState } from 'react'
import { RENEW_PAGE_ADJUST_CAR_VALUE, RENEW_PAGE_CHOOSE_DOWNGRADE_PLAN, RENEW_PAGE_CPR_NUMBER, RENEW_PAGE_CPR_PLATE_NUMBER, RENEW_PAGE_ENHANCE_YOUR_COVERAGE, RENEW_PAGE_LOGIN_OTP, RENEW_PAGE_REVIEW_AND_CONFIRM, RENEW_PAGE_REVIEW_YOUR_POLICY, RENEW_PAGE_SELECT_POLICY, RENEW_PAGE_VERIFY_OTP } from './data';
import AdjustCarValuePage from './adjustCarValuePage/adjustCarValuePage';
import ChooseDowngradePlanPage from './chooseDowngradePlanPage/chooseDowngradePlanPage';
import CprNumberPage from './cprNumberPage/cprNumberPage';
import EnhanceYourCoveragePage from './enhanceYourCoveragePage/enhanceYourCoveragePage';
import ReviewAndConfirmPage from './reviewAndConfirmPage/reviewAndConfirmPage';
import ReviewYourPolicyPage from './reviewYourPolicyPage/reviewYourPolicyPage';
import SelectPoliciesPage from './selectPoliciesPage/selectPoliciesPage';
import VerifyOtpPage from './verifyOtpPage/verifyOtpPage';
import Modal from '../../../components/common/modal/modal';
import Header from '../../../components/common/Header/Header';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import closeicon from '../../../assets/images/close.svg';
import useLanguageTranslate from '../../../hooks/useLanguageTranslate';
import useQuickRenewalFlow from '../../../hooks/useQuickRenewalFlow';
import CprPlateNumberPage from './cprNumberPage/cprPlateNumberPage';
import QuickRenewalCprPlateNumberPage from './quickRenewalMotorPolicy/quickRenewalCprPlateNumber';
import QuickRenewalLoginOtpPage from './quickRenewalMotorPolicy/quickRenewalLoginOtpPage';

const QuickRenewalMotorPolicy = () => {
    const {currentStep} = useQuickRenewalFlow()
    const navigate = useNavigate();
    const translate = useLanguageTranslate();
    const { i18n } = useTranslation();
    const isRTL = i18n.resolvedLanguage === "ar";

    // Home, which is where the desktop close already goes: this route is in
    // none of the Header's path lists, so its optionalcloseClickHanlder falls
    // through every branch to goToHome(). The two closes should not disagree
    // about where the flow ends just because of the viewport.
    const handleClose = () => navigate("/");

    console.log(currentStep,'some current step')
    const PageRenderer = () => {
        switch (currentStep?.name) {
            // case RENEW_PAGE_CPR_NUMBER:
            //     return <CprNumberPage />
            case RENEW_PAGE_CPR_PLATE_NUMBER:
                return <QuickRenewalCprPlateNumberPage />
            case RENEW_PAGE_LOGIN_OTP:
                return <QuickRenewalLoginOtpPage />
            // case RENEW_PAGE_ADJUST_CAR_VALUE:
            //     return <AdjustCarValuePage />
            // case RENEW_PAGE_CHOOSE_DOWNGRADE_PLAN:
            //     return <ChooseDowngradePlanPage />
            // case RENEW_PAGE_ENHANCE_YOUR_COVERAGE:
            //     return <EnhanceYourCoveragePage />
            case RENEW_PAGE_REVIEW_AND_CONFIRM:
                return <ReviewAndConfirmPage />
            // case RENEW_PAGE_REVIEW_YOUR_POLICY:
            //     return <ReviewYourPolicyPage />;
            // case RENEW_PAGE_SELECT_POLICY:
            //     return <SelectPoliciesPage />;
            // case RENEW_PAGE_VERIFY_OTP:
            //     return <VerifyOtpPage />;
            default:
                return null
        }
    };
    return (
        <>
            {/* The flow's close on a phone, in the top-left, matching every
                other policy flow. This route had none at all: SideNavbar
                renders the Header only when `!isPopup || !mobile`, and this is
                a popup route that renders no Header of its own — so on a phone
                there was no chrome above the content and no way out of the
                flow short of the browser's own back button.

                `fixed` and `z-[100]` for the same reasons as the other
                layouts: it must not scroll away with the page, and it must
                clear anything that paints over those top pixels. */}
            <div className="block md:hidden">
                <button
                    type="button"
                    className={`flex items-center justify-center w-10 h-10 fixed top-3 rounded-full bg-[#F6F8F9] hover:bg-gray-200 transition-colors z-[100] ${
                        isRTL ? "right-4" : "left-4"
                    }`}
                    aria-label={translate("Close", "إغلاق")}
                    onClick={handleClose}
                >
                    <img src={closeicon} alt="Close" className="w-5 h-5" />
                </button>
            </div>

            {/* `max767:pt-[72px]` clears that button, which runs from 12px to
                52px down the screen, and leaves 20px of air under it before
                the title. Nothing else occupies the top of this route on a
                phone — there is no 48px header bar as on the other motor
                flows — and the first step's own `max767:pt-0` would otherwise
                put its title hard against the top of the screen. */}
            <div className="mainCarDetailsModal pt-[1%] pb-[5%] max767:pt-[72px] max767:w-full max767:overflow-y-scroll max767:pb-[30%] max767:h-screen ipad:pt-[10%] ipad:h-[93vh] ipad:overflow-y-scroll ">
                {PageRenderer()}
            </div>
        </>
    )
}

export default QuickRenewalMotorPolicy